var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-service',{scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.ctiList.length && !_vm.ctiList.status)?_c('base-table',{attrs:{"items":_vm.ctiList,"fields":_vm.fields,"isHeader":false}}):_vm._e()]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }